module.exports = __webpack_public_path__ + "img/block-right-medium.439e9ca9.png";